//messages.js
export default {
    scrap_auth_id: "Scrap Auth #",
    nonconformance_id: "Nonconformance #",
    corrective_action: "Corrective Action",
    car_number: "CAR #",
    company_id: "Company Id",
    part_id: "Part #",
    batch_id: "Batch #",
    quality_mgr_id: "Quality Manager/Designee",
    quality_mgr_date: "Date",
    sales_mgr_id: "Sales Manager/Designee",
    sales_mgr_date: "Date",
    ehs_mgr_id: "EHS Manager/Designee",
    ehs_mgr_date: "Date",
    production_mgr_id: "Production Manager/Designee",
    production_mgr_date: "Date",
    executive_id: "Executive Approval",
    executive_date: "Date",
    qty_scrapped: "Qty Scrapped",
    rma_number: "RMA #",
    part_cost_estimate: "Part Cost Estimate",
    edit_scrap_authorization: "Edit Scrap Authorization",
    add_scrap_authorization: "Add Scrap Authorization",
    delete_scrap_authorization: "Delete Scrap Authorization",
    scrap_authorizations: "Scrap Authorizations",
    delete_scrap_authorization_confirm: "This action is not reversible!",
    in_process: "Corrective Action in process",
    not_in_process: "No Corrective Action",
    info_scrap_authorization:
        "All parts that meet the definition of scrap must be placed in a scrap container or returned to the customer if requested after the Sales, Production and Quality Manager's or Designee's have signed off on the Scrap Authorization Form.",
    viewScrapAuth: "View Scrap Authorization",
    addScrapAuth: "Add Scrap Authorization",
    printScrapAuth: "Print Scrap Authorization",
    no_scrap_auth: "No Scrap Authorization",
};
